<template>
  <div>
    <Collapse v-model="value" simple style="border: 0">
      <Panel name="6" hide-arrow style="margin: 20px 0; border: 0">
        <FormTitle titleText="基本信息" />
        <Form
          :label-width="150"
          label-position="left"
          slot="content"
          style="margin: 30px 30px 0 30px"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工工号">
                <Input v-model="userinfoItem.empCode" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工姓名">
                <Input v-model="userinfoItem.userName" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工职位">
                <Input v-model="userinfoItem.positionName" disabled />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="选择需要总结的目标">
                <Input
                  type="text"
                  v-model="userinfoItem.applyNo"
                  placeholder=""
                  disabled
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="月份">
                <Input v-model="userinfoItem.month" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
        </Form>
      </Panel>

      <Panel
        v-show="showKPI"
        name="1"
        hide-arrow
        style="margin: 20px 0; border: 0"
      >
        <FormTitle titleText="KPI" />
        <div slot="content" style="margin-top: 20px">
          <Table border :columns="columns1" :data="data1">
            <template slot-scope="{ row, index }" slot="action12">
              <Button
                icon="md-create"
                type="warning"
                size="small"
                style="margin-right: 8px"
                @click="editKPI(row, index)"
                :disabled="isHistory"
                >编辑</Button
              >
            </template>
          </Table>
          <div v-show="showKPIDetail" style="margin-top: 30px">
            <Table border :columns="columns2" :data="data2"> </Table>
          </div>
          <Modal v-model="openKPI" title="编辑" width="600px">
            <div class="center" style="padding: 0 40px">
              <Form :label-width="170" label-position="left">
                <FormItem label="指标项">
                  <Input v-model="formItem1.targetItem" disabled />
                </FormItem>
                <FormItem label="内容概述">
                  <Input v-model="formItem1.content" disabled />
                </FormItem>
                <FormItem label="权重（%）">
                  <Input v-model="formItem1.weight" disabled />
                  <span class="weight-style">%</span>
                </FormItem>
                <FormItem label="评分方法">
                  <Input v-model="formItem1.method" disabled />
                </FormItem>
                <FormItem label="数据来源">
                  <Input v-model="formItem1.dataFrom" disabled />
                </FormItem>
                <FormItem label="完成度">
                  <Input v-model="formItem1.completeExtent" disabled />
                </FormItem>
                <FormItem label="自评">
                  <Input v-model="formItem1.evaSelf" disabled />
                </FormItem>
                <FormItem label="他评">
                  <Input v-model="formItem1.evaOther" />
                </FormItem>
                <!-- <FormItem label="得分">
                  <Input v-model="formItem1.score" disabled/>
                </FormItem> -->
              </Form>
            </div>
            <div slot="footer">
              <Button @click="confirmKPI">确定</Button>
            </div>
          </Modal>
        </div>
      </Panel>
      <Panel
        v-show="showBSC"
        name="2"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
      >
        <FormTitle titleText="BSC" />
        <div slot="content" style="margin-top: 20px">
          <Table border :columns="columns3" :data="data3" width="400"> </Table>
          <div v-show="showBSCDetail" style="margin: 30px 0">
            <Table border :columns="columns4" :data="data4">
              <template slot-scope="{ row, index }" slot="action32">
                <Button
                  icon="md-create"
                  type="warning"
                  size="small"
                  style="margin-right: 8px"
                  @click="editBSCDetail(row, index)"
                  :disabled="isHistory"
                  >编辑</Button
                >
              </template>
            </Table>
          </div>
          <Modal v-model="openBSCDetail" title="编辑" width="600px">
            <div class="center" style="padding: 0 40px">
              <Form :label-width="150" label-position="left">
                <FormItem label="指标维度">
                  <Input v-model="formItem4.targetDemensionRepeat" disabled />
                </FormItem>
                <FormItem label="衡量要素">
                  <Input v-model="formItem4.measure" disabled />
                </FormItem>
                <FormItem label="指标名称">
                  <Input v-model="formItem4.targetName" disabled />
                </FormItem>
                <FormItem label="指标定义">
                  <Input
                    v-model="formItem4.targetDefine"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    disabled
                  />
                </FormItem>
                <FormItem label="设立目的">
                  <Input
                    v-model="formItem4.aimFound"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    disabled
                  />
                </FormItem>
                <FormItem label="数据收集">
                  <Input v-model="formItem4.dataCollect" disabled />
                </FormItem>
                <FormItem label="备注">
                  <Input v-model="formItem4.remark" disabled />
                </FormItem>
                <FormItem label="完成度">
                  <Input v-model="formItem4.completeExtent" disabled />
                </FormItem>
                <FormItem label="自评">
                  <Input v-model="formItem4.evaSelf" disabled />
                </FormItem>
                <FormItem label="他评">
                  <Input v-model="formItem4.evaOther" />
                </FormItem>
                <!-- <FormItem label="得分">
                  <Input v-model="formItem4.score" disabled />
                </FormItem> -->
              </Form>
            </div>
            <div slot="footer">
              <Button @click="confirmBSCDetail">确定</Button>
            </div>
          </Modal>
        </div>
      </Panel>
      <Panel
        v-show="showPlan"
        name="3"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
      >
        <FormTitle titleText="个人发展计划" />
        <div v-show="showPlan" style="margin-top: 30px" slot="content">
          <Table border :columns="columns5" :data="data5">
            <template slot-scope="{ row, index }" slot="action5">
              <Button
                icon="md-create"
                type="warning"
                size="small"
                style="margin-right: 8px"
                @click="editPlan(row, index)"
                :disabled="isHistory"
                >编辑</Button
              >
            </template>
          </Table>
        </div>
        <Modal v-model="openPlan" title="编辑" width="600px">
          <div class="center" style="padding: 0 40px">
            <Form :label-width="230" label-position="left">
              <FormItem label="待提高或发展的能力/经验">
                <Input
                  v-model="formItem5.heighten"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  disabled
                />
              </FormItem>
              <FormItem
                label="实施活动及衡量标准（活动要具体、个性化、可衡量）"
              >
                <Input
                  v-model="formItem5.activesPerformed"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  disabled
                />
              </FormItem>
              <FormItem label="计划完成时间（计划要可执行）">
                <DatePicker
                  v-model="formItem5.completeDate"
                  style="width: 100%"
                  disabled
                ></DatePicker>
              </FormItem>
              <FormItem label="完成度">
                <Input v-model="formItem5.completeExtent" disabled />
              </FormItem>
              <FormItem label="描述">
                <Input v-model="formItem5.midDescribe" disabled />
              </FormItem>
              <FormItem label="自评">
                <Input v-model="formItem5.evaSelf" disabled />
              </FormItem>
              <FormItem label="备注">
                <Input v-model="formItem5.comment" disabled />
              </FormItem>
            </Form>
          </div>
          <div slot="footer">
            <Button @click="confirmPlan">确定</Button>
          </div>
        </Modal>
      </Panel>
      <Panel
        v-show="showWork"
        name="4"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
      >
        <FormTitle titleText="重点工作" />
        <div slot="content" style="margin-top: 20px">
          <Table border :columns="columns6" :data="data6">
            <template slot-scope="{ row, index }" slot="action6">
              <Button
                icon="md-create"
                type="warning"
                size="small"
                style="margin-right: 8px"
                @click="editWork(row, index)"
                :disabled="isHistory"
                >编辑</Button
              >
            </template>
          </Table>
          <Modal v-model="openWork" title="编辑" width="600px">
            <div class="center" style="padding: 0 40px">
              <Form :label-width="170" label-position="left">
                <FormItem label="解决的挑战及目标描述">
                  <Input v-model="formItem6.describe" disabled />
                </FormItem>
                <FormItem label="完成的标准及交附件">
                  <Input
                    v-model="formItem6.standard"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    disabled
                  />
                </FormItem>
                <FormItem label="权重（%）">
                  <Input v-model="formItem6.weight" disabled />
                  <span class="weight-style">%</span>
                </FormItem>
                <FormItem label="关键举措">
                  <Input v-model="formItem6.initiatives" disabled />
                </FormItem>
                <FormItem label="完成度">
                  <Input v-model="formItem6.completeExtent" disabled />
                </FormItem>
                <FormItem label="描述">
                  <Input v-model="formItem6.midDescribe" disabled />
                </FormItem>
                <FormItem label="自评">
                  <Input v-model="formItem6.evaSelf" disabled />
                </FormItem>
                <FormItem label="备注">
                  <Input v-model="formItem6.comment" disabled />
                </FormItem>
              </Form>
            </div>
            <div slot="footer">
              <Button @click="confirmWork">确定</Button>
            </div>
          </Modal>
        </div>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle titleText="审批历史" style="margin-top:20px" />
        <Table
          border
          :columns="columns9"
          :data="data9"
          slot="content"
          style="margin:20px"
        >
        </Table>
      </Panel>
    </Collapse>
    <div class="btnRight">
      <Button
        type="primary"
        class="applyBtnRight"
        @click="submit"
        v-if="!isHistory"
        >同意</Button
      >
      <Button
        type="primary"
        class="applyBtnRight"
        @click="reject"
        v-if="!isHistory"
        >驳回</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnPage"
        >返回</Button
      >
    </div>
    <Modal
      v-model="showdataAgree"
      title="请填写审批意见"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">确定</Button>
        <Button @click="cancell1">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      title="请填写驳回意见"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">确定</Button>
        <Button @click="cancell2">取消</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value: [1, 2, 3, 4, 5, 6],
      formItem1: {},
      formItem4: {},
      formItem5: {},
      formItem6: {},
      columns: [
        {
          title: "申请单号",
          key: "applyNo",
          align: "center"
        },
        {
          title: "申请人名称",
          key: "applyName",
          align: "center"
        },
        {
          title: "职位",
          key: "applyPositionName",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "120"
        }
      ],
      data: [],
      // KPI 指标
      columns1: [
        {
          title: "指标项",
          key: "targetItem",
          align: "center"
        },
        {
          title: "内容概述",
          key: "content",
          align: "center",
          width: "330"
        },
        {
          title: "权重（%）",
          key: "weight",
          align: "center"
        },
        {
          title: "评分方法",
          key: "method",
          align: "center"
        },
        {
          title: "数据来源",
          key: "dataFrom",
          align: "center"
        },
        {
          title: "完成度",
          width: "100",
          key: "completeExtent"
        },
        {
          title: "自评",
          width: "100",
          key: "evaSelf"
        },
        {
          title: "他评",
          width: "100",
          key: "evaOther"
        },
        // {
        //   title: "得分",
        //   width: "100",
        //   key: "score",
        // },
        {
          title: "操作",
          slot: "action12",
          align: "center",
          width: "200"
        }
      ],
      data1: [],
      // 指标->子表格
      columns2: [
        {
          title: "指标项",
          key: "targetItemRepeat",
          align: "center"
        },
        {
          title: "内容概述",
          key: "contentRepeat",
          align: "center"
        },
        {
          title: "目标分解",
          key: "targetDisintegrate",
          align: "center"
        },
        {
          title: "达成效果",
          key: "reachEffect",
          align: "center"
        }
      ],
      data2: [],
      // bsc
      columns3: [
        {
          title: "指标维度",
          key: "targetDimension",
          align: "center"
        }
      ],
      data3: [],
      // bsc -> 子表格
      columns4: [
        {
          title: "指标维度",
          key: "targetDemensionRepeat",
          width: "250",
          align: "center"
        },
        {
          title: "衡量要素",
          key: "measure",
          width: "180",
          align: "center"
        },
        {
          title: "指标名称",
          key: "targetName",
          width: "180",
          align: "center"
        },
        {
          title: "指标定义",
          key: "targetDefine",
          width: "180",
          align: "center"
        },
        {
          title: "设立目的",
          key: "aimFound",
          width: "180",
          align: "center"
        },
        {
          title: "数据收集",
          key: "dataCollect",
          width: "180",
          align: "center"
        },
        {
          title: "备注",
          key: "remark",
          width: "180",
          align: "center"
        },
        {
          title: "完成度",
          width: "120",
          align: "center",
          key: "completeExtent"
        },
        {
          title: "自评",
          width: "120",
          align: "center",
          key: "evaSelf"
        },
        {
          title: "他评",
          width: "120",
          align: "center",
          key: "evaOther"
        },
        // {
        //   title: "得分",
        //   width: "100",
        //   align: "center",
        //   key: "score",
        // },
        {
          title: "操作",
          slot: "action32",
          align: "center",
          width: "120",
          fixed: "right"
        }
      ],
      data4: [],
      // 个人发展计划
      columns5: [
        {
          title: "待提高或发展的能力/经验",
          key: "heighten",
          align: "center",
          width: "265"
        },
        {
          title: "实施活动及衡量标准（活动要具体、个性化、可衡量）",
          key: "activesPerformed",
          align: "center",
          width: "400"
        },
        {
          title: "计划完成时间（计划要可执行）",
          key: "completeDate",
          align: "center",
          width: "290",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.completeDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "完成度（%）",
          width: "120",
          key: "completeExtent"
        },
        {
          title: "描述",
          width: "120",
          key: "midDescribe"
        },
        {
          title: "自评",
          width: "120",
          key: "evaSelf"
        },
        {
          title: "备注",
          width: "120",
          key: "comment"
        },
        {
          title: "操作",
          slot: "action5",
          align: "center",
          width: "150"
        }
      ],
      data5: [],
      // 重点工作
      columns6: [
        {
          title: "解决的挑战及目标描述",
          key: "describe",
          align: "center",
          width: "300"
        },
        {
          title: "完成的标准及交附件",
          key: "standard",
          align: "center",
          width: "235"
        },
        {
          title: "权重（%）",
          key: "weight",
          align: "center",
          width: "150"
        },
        {
          title: "关键举措",
          key: "initiatives",
          align: "center",
          width: "150"
        },
        {
          title: "完成度（%）",
          key: "completeExtent",
          width: "150"
        },
        {
          title: "描述",
          key: "midDescribe",
          width: "150"
        },
        {
          title: "自评",
          key: "evaSelf",
          width: "150"
        },
        {
          title: "备注",
          key: "comment",
          width: "150"
        },
        {
          title: "操作",
          slot: "action6",
          align: "center",
          width: "150"
        }
      ],
      data6: [],
      loading: false,
      showKPI: false,
      showBSC: false,
      showKPIDetail: false,
      showBSCDetail: false,
      showPlan: false,
      showWork: false,
      isHistory: false,
      openKPI: false,
      kpiAction: 0,
      KPIActionIndex: "",
      kpiRow: {},
      kpiIndex: 0,
      openBSCDetail: false,
      bscDetailIndex: "",
      openPlan: false,
      planAction: 0,
      planActionIndex: "",
      openWork: false,
      workActionIndex: "",
      userinfoItem: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      openSelectApplyNo: false,
      ruleValidate: {
        message: [{ required: true, message: this.$t("请填写驳回意见") + "！" }]
      },
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      rejectMessage: {},
      columns9: [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "270",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ],
      data9: []
    };
  },
  watch: {
    evaOther() {
      if (this.formItem1.evaOther && this.formItem1.evaSelf) {
        this.formItem1.score =
          (0.3 * Number(this.formItem1.evaSelf) +
            0.7 * Number(this.formItem1.evaOther)) *
          this.formItem1.weight; //*绩效类型设定值
      }
    }
  },
  mounted() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
    this.getData();
  },
  methods: {
    getData(row, index) {
      let obj1 = {
        instanceId: this.getQueryVariable("instanceId")
      };
      this.loading = true;
      this.openSelectApplyNo = false;
      axios.post("/AchMidYear/selectMidYear", obj1).then(res1 => {
        this.loading = false;
        this.data1 = res1.kpi;
        this.data3 = res1.bsc;
        this.data5 = res1.plan;
        this.data6 = res1.work;
        this.data9 = res1.logMap;
        this.data4 = res1.bscdecomposeList;
        this.data2 = res1.kpidecomposeList;
        this.userinfoItem = res1.basicInfo;
        let arr = res1.typeList;
        if (arr && arr != null) {
          arr.forEach(item => {
            if (item.achTypeCode == "work") {
              this.showWork = true;
            } else if (item.achTypeCode == "kpi") {
              this.showKPI = true;
              this.showKPIDetail = true;
            } else if (item.achTypeCode == "bsc") {
              this.showBSC = true;
              this.showBSCDetail = true;
            } else if (item.achTypeCode == "plan") {
              this.showPlan = true;
            }
          });
        }
      });
    },
    editKPI(row, index) {
      this.openKPI = true;
      this.formItem1 = { ...row };
      this.KPIActionIndex = index;
      this.kpiAction = 2;
    },
    confirmKPI() {
      this.kpiIndex = this.KPIActionIndex;
      if (this.kpiAction == 1) {
        this.data1.push(this.formItem1);
        this.data2 = [];
      } else if (this.kpiAction == 2) {
        this.kpiRow = this.formItem1;
        this.data1.splice(this.kpiIndex, 1, this.kpiRow);
      }
      this.openKPI = false;
    },
    editBSCDetail(row, index) {
      this.openBSCDetail = true;
      this.formItem4 = { ...row };
      this.bscDetailIndex = index;
    },
    confirmBSCDetail() {
      this.data4.splice(this.bscDetailIndex, 1, this.formItem4);
      this.openBSCDetail = false;
    },
    editPlan(row, index) {
      this.openPlan = true;
      this.formItem5 = { ...row };
      this.planActionIndex = index;
    },
    confirmPlan() {
      this.data5.splice(this.planActionIndex, 1, this.formItem5);
      this.openPlan = false;
    },
    editWork(row, index) {
      this.openWork = true;
      this.formItem6 = { ...row };
      this.workActionIndex = index;
    },
    confirmWork() {
      this.data6.splice(this.workActionIndex, 1, this.formItem6);
      this.openWork = false;
    },
    submit() {
      this.$Modal.confirm({
        title: this.$notice("submission"),
        content: "",
        onOk: () => {
          this.handle();
        },
        onCancel: () => {}
      });
    },
    submit() {
      this.showdataAgree = true;
    },
    reject() {
      this.showdataRejected = true;
    },
    yess1() {
      this.showdataAgree = false;
      let arr1 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          stringData2: this.rejectMessage.message,
          type: "B17"
        }
      ];
      this.loading = true;
      axios.post("/process/execute", arr1).then(res => {
        this.loading = false;
        if (res) {
          let arr1 = [this.data5, this.data1, this.data3, this.data6],
            arr2 = [this.data2, this.data4];
          axios
            .post("/AchMidYear/updateMidDetailsEvaOther", arr1)
            .then(res5 => {
              if (res5 && res5 != null) {
                axios
                  .post("/AchMidYear/updateMidDecoEvaOther", arr2)
                  .then(res6 => {
                    if (res6 && res6 != null) {
                      this.$Message.info(this.$t("Approval_Completed"));
                      this.$router.push(
                        "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
                      );
                    }
                  });
              }
            });
        }
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.loading = true;
          axios.post("/process/execute", arr).then(res => {
            this.loading = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    returnPage() {
      if (this.getQueryVariable("isProcessList") == "true") {
        this.$router.push(
          "/3643BE389560158D15632DBE8934C23596BCE18CD6B2387A/A3FFBEBFDB713E27"
        );
      } else if (this.isHistory) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.weight-style {
  position: absolute;
  top: 0;
  right: 0;
  display: table-cell;
  white-space: nowrap;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ApprovalAchMidYear.vue